import { NgModule } from '@angular/core';
import { LlTabsComponent } from './ll-tabs.component';

@NgModule({
    declarations: [
        LlTabsComponent
    ],
    exports: [
        LlTabsComponent
    ]
})
export class LlTabsCoreModule {}